import { useFormikSubmit } from "@certn/api";
import {
  GhostIconButton,
  TextAreaFormikField,
  useColors,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Form, Formik } from "formik";
import { t } from "i18next";
import { useParams } from "react-router-dom";

import { useUser } from "../../hooks/useUser";

interface props {
  mutate: any;
}
export function CommentForm(props: props) {
  const { mutate } = props;
  const colors = useColors();
  const { caseId } = useParams();
  const { details: userDetails } = useUser();

  const { submit } = useFormikSubmit(
    `/api/internal/client-portal/case-comments/create/`,
    {
      throwErrors: true,
      showToastOnError: true,
      resetOnSuccess: true,
      onSuccess: () => {
        mutate();
      },
    }
  );
  const initialValues = {
    message: "",
    case_short_id: caseId,
  };

  return (
    <Formik initialValues={initialValues} onSubmit={submit}>
      {({ isSubmitting }) => {
        return (
          <Form
            className={css(styles.form, {
              borderTop: `1px solid ${colors["border-base"]}`,
            })}
          >
            <TextAreaFormikField
              isDisabled={userDetails?.is_proxy_user}
              label=""
              aria-label="add-comment-input-field"
              name="message"
              isRequired
              testID="add-comment-text-input-field"
              placeholder={t("Add a comment...")}
              resize="vertical"
              className={styles.textField}
              minHeight={40}
            />
            <GhostIconButton
              isDisabled={userDetails?.is_proxy_user}
              type="submit"
              size="small"
              testID="save-comment-button"
              icon="send"
              isLoading={isSubmitting}
            >
              {t("Save")}
            </GhostIconButton>
          </Form>
        );
      }}
    </Formik>
  );
}

const styles = {
  form: css({
    display: "flex",
    padding: `${"var(--space-3)"} ${"var(--space-3)"} ${"var(--space-3)"}`,
    flexDirection: "row",
    alignItems: "center",
    gap: "var(--space-2)",
  }),
  textField: css({
    width: "100%",
    maxHeight: "168px",
  }),
};
